var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat5E01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 2.5,
    y1: 8,
    x2: 3.2,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.7,
    y1: 8,
    x2: 4.3,
    y2: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "4.7,8 5.6,8 5.9,8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.1,
    y1: 8,
    x2: 7,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,8h0.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9,
    y1: 8,
    x2: 9.7,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 8,
    x2: 10.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.8,
    y1: 8,
    x2: 11.4,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.7,
    y1: 8,
    x2: 12.6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 8,
    x2: 13.5,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.1,
    y1: 8,
    x2: 8.8,
    y2: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat5E01);
export default __webpack_public_path__ + "static/media/CAT5E-01.c05548ef4a451710ebf021e501fde21b.svg";
export { ForwardRef as ReactComponent };